<section class="get-started-widget">
  <app-library-title [title]="blockTitle"></app-library-title>

  <div class="informer-wrap">
    <ng-template [ngIf]="isTeacher" [ngIfElse]="student">
      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_1.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer1.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer1.text' | customLocale }}</span>
        </div>
        <a routerLink="/constructor" class="link normal">{{ 'news.get-started.informer1.link' | customLocale }}</a>
      </div>

      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_2.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer2.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer2.text' | customLocale }}</span>
        </div>
        <a [routerLink]="'/' + route.tutors" class="link normal"
           disabled="true">{{ 'news.get-started.informer2.link' | customLocale }}</a>
      </div>

      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_3.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer3.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer3.text' | customLocale }}</span>
        </div>
        <a *ngIf="!isGuest" routerLink="/go/class" class="link normal">{{ 'news.get-started.informer3.link' | customLocale }}</a>
        <div *ngIf="isGuest" class="link normal" (click)="auth()">{{ 'news.get-started.informer3.link' | customLocale }}</div>
      </div>
    </ng-template>

    <ng-template #student>
      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_4.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer4.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer4.text' | customLocale }}</span>
        </div>
        <a routerLink="/lessons" class="link normal">{{ 'news.get-started.informer4.link' | customLocale }}</a>
      </div>

      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_5.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer5.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer5.text' | customLocale }}</span>
        </div>
        <a [routerLink]="'/' + route.tutors" class="link normal">{{ 'news.get-started.informer5.link' | customLocale }}</a>
      </div>

      <div class="informer">
        <div class="cover" [lazyLoad]="assetsUrl('/assets/images/get_started/get_started_cover_3.jpg')"></div>
        <div class="text-wrap">
          <h3 class="title bold">{{ 'news.get-started.informer6.title' | customLocale }}</h3>
          <span class="text normal">{{ 'news.get-started.informer6.text' | customLocale }}</span>
        </div>
        <div class="link normal disabled">{{ 'news.get-started.informer6.link' | customLocale }}</div>
      </div>
    </ng-template>
  </div>
</section>
